import React from 'react';
import {Link} from 'react-router-dom';
import Moment from 'react-moment';

const deal = (props) => {
    return (
        <Link to={process.env.PUBLIC_URL+'/allday/entry-pass/'+props.deal._id} className="each--associatehost-row overlay-bg p-t-15">
            <div className="row">
                <div className="col-sm-12 col-12">
                    <div className="eacch--associatehost-outer d-mob-flex d-md-flex d-lg-flex custom-w-100">
                        <div className="each--associatehost-pic">
                            <img src={props.deal.image} alt={props.deal.name}/>
                        </div>
                        <div className="each--associatehost-info">
                            <h6 className="each--associatehost-info-heading custom-height text_color_green">{props.deal.category.name}</h6>
                            <p className="each--associatehost-info-para custom-height">{props.deal.name}</p>
                            <div className="d-flex align-items-center justify-content-between custom-mt-15">
                                <p className="each--associatehost-info-para"><Moment format="DD MMM" parse="DD-MM-YYYY">{props.deal.purchased_for_date}</Moment> <br/>({props.deal.is_redeemed ? 'Redeemed' : 'Not Redeemed'})</p>
                                <div className="view-host-deals">
                                    <Link to={process.env.PUBLIC_URL+'/allday/entry-pass/'+props.deal._id} className="grad-on cart-view-btn fav-custom-btn">View Details</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default deal;